module.exports = __webpack_public_path__ + "media/images/lb/231-1ced7d88773f36a96330163849c4d6da.svg";